import { useState } from "react";

export function Credits() {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      {/* Button to open credits */}
      <button
        className="credits-button"
        onClick={() => setIsVisible(true)}
        title="Credits"
      >
        INFO
      </button>

      {/* Credits modal */}
      {isVisible && (
        <div className="credits-overlay" onClick={() => setIsVisible(false)}>
          <div className="credits-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="credits-close"
              onClick={() => setIsVisible(false)}
            >
              ✕
            </button>

            <div className="credits-content">
              <h2 className="credits-title"> ☕ Coffee Between Moods</h2>

              <div className="credits-section">
                <h3>Created for</h3>
                <p>
                  <strong>Bruno Simon's 20th Three.js Journey Challenge</strong>
                  <br />
                  Theme: Cozy Place
                </p>
              </div>

              <div className="credits-section">
                <h3>🎨 Credits</h3>
                <p>
                  <strong>3D Assets</strong>
                  <br />
                  All assets are made by me! (I suffered a lot to make them,
                  especially UV unwrapping and baking)
                </p>
                <p>
                  <strong>HDR Texture</strong>
                  <br />

                  <a
                    href="https://polyhaven.com/a/warm-bar-terrace"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Greg Zaal and Jarod Guest (Poly Haven)
                  </a>
                </p>
                <p>
                  <strong>Music</strong>
                  <br />{" "}
                  <a
                    href="https://rustedstudio.itch.io/free-music-ambient-lofi-jazz-mp3-midi"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ambient LoFi Jazz by Rusted Music Studio
                  </a>
                </p>
              </div>

              <div className="credits-section">
                <h3>🛠️ Built with</h3>
                <ul>
                  <li>
                    <strong>React Three Fiber / Three.js</strong> - 3D rendering
                  </li>
                  <li>
                    <strong>React Three Drei</strong> - utilities
                  </li>
                  <li>
                    <strong>Zustand</strong> - state management
                  </li>
                  <li>
                    <strong>Vite</strong> - build tool
                  </li>
                </ul>
              </div>

              <div className="credits-section">
                <h3>🛠️ Debug Mode</h3>
                <p>
                  Add <strong>#debug</strong> to the URL to access performance
                </p>
              </div>

              <div className="credits-section">
                <h3>👨‍💻 Author</h3>
                <p>
                  <strong>Adam Alet</strong>
                  <br />
                  <a
                    href="https://x.com/nihdao"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    @nihdao
                  </a>
                </p>
              </div>

              <div className="credits-footer">
                <p>Big kudos for the Three.js community</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
